<template>
	<div class="log"></div>
</template>

<script>
export default {
	created() {
		this.$store.dispatch('login/userLogOut').then(() => {
			this.$router.push({ name: 'login' });
		})
		.catch((error) => {
			console.log('error en logout')
			throw(error)
		})
	},
};
</script>

<style>
</style>